import Marquee from "react-fast-marquee";

const WORDS = [
  "Hidratación profunda",
  "Renueva tu piel",
  "Frescura natural",
  "Poder botánico",
  "Talones suaves",
];

export const EditorialMarquee = () => (
  <section
    data-testid="marquee-section"
    className="border-y border-line bg-mutedbg/60 py-6 md:py-8"
  >
    <Marquee speed={38} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif italic font-light text-3xl md:text-5xl text-ink/80 px-8">
            {w}
          </span>
          <span className="text-accent text-2xl md:text-3xl">•</span>
        </span>
      ))}
    </Marquee>
  </section>
);
